import { Loading } from "quasar";
import { supabase } from "src/boot/supabase";

export async function syncUserToSendfox(email, name = "", userId = null) {
  if (!email) {
    throw new Error("E-mailadres ontbreekt voor de nieuwsbriefkoppeling.");
  }

  const { data, error } = await supabase.functions.invoke("syncUserToSendfox", {
    body: { email, name, userId },
  });

  if (error) {
    const details = await error.context?.json?.().catch(() => null);
    throw new Error(
      details?.message ||
        "De nieuwsbriefkoppeling is niet gelukt. Probeer het later opnieuw."
    );
  }
  if (!data?.subscribed) {
    throw new Error(data?.message || "Nieuwsbriefkoppeling is niet voltooid.");
  }
  // Refresh the server-owned sync status displayed on the account page.
  await supabase.auth.refreshSession().catch(() => null);
  return data;
}

export async function fetchUsersSendfoxStatus() {
  Loading.show({
    message: "Loading users with SendFox status...",
  });
  try {
    const { data, error } = await supabase.functions.invoke(
      "listUsersWithSendfoxStatus",
      { method: "GET" }
    );
    if (error) throw error;
    if (!Array.isArray(data)) {
      console.error("Unexpected data format", data);
      return [];
    }
    //console.log("Fetched users with SendFox status:", data);
    // Filter out users without a SendFox status
    return data;
  } catch (error) {
    console.error("Error fetching users with SendFox status:", error);
    return [];
  } finally {
    Loading.hide();
  }
}
